/* eslint-disable @typescript-eslint/no-unused-vars */

import { updateComponent } from '../../../../app/package-designer/store/component.actions';

xplenty.directive('sampleEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./sample-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        'ngrxStoreService',
        function ($scope, ngrxStoreService) {
          $scope.onPercentageChange = ({ percentage }) => {
            const component = { percentage };
            ngrxStoreService.dispatch(updateComponent({ component }));
          };

          $scope.$watch('component.percentage', function () {
            const valid =
              !!$scope.component.percentage && $scope.component.percentage >= 0 && $scope.component.percentage <= 100;

            $scope.onValidityChange(valid);
          });
        },
      ],
    };
  },
]);
